const images = {
    logo1: require('../assets/images/logo1.png').default,
    avt: require('../assets/images/avt.jpg')
}

export default images